export const helpList = [
    {
        text: '为什么企业标记号码认证会被拒绝？',
        routerPath: '/help'
    },
    {
        text: '如何知道企业/个人号码是否被用户标记为诈骗、骚扰等？',
        routerPath: '/help'
    },
    {
        text: '为什么企业/个人号码在号码申诉时会被拒绝？',
        routerPath: '/help'
    },
    {
        text: '提交资料后，什么时候会审核完毕？',
        routerPath: '/help'
    },
    {
        text: '企业/个人号码申诉成功后，为什么百度搜索或通话时还会显示标记？',
        routerPath: '/help'
    },
    {
        text: '百度号码服务平台是否会泄露企业/个人身份信息？',
        routerPath: '/help'
    }
];